module.exports = __webpack_public_path__ + "static/media/img_fecularia_apresentacao.5857e8c3.jpg";